import { Component, OnInit } from '@angular/core';
import { MioAccessDialogComponent } from './mio-access-dialog/mio-access-dialog.component';
import { MioService, IMioRegion, IMioLivingComplex, IMioLicense } from './mio.service';
import { combineLatest } from 'rxjs';
import { IMyDpOptions } from 'mydatepicker';
import * as moment from 'moment';
import {MatDialog} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-mio',
  templateUrl: './mio.component.html',
  styleUrls: ['./mio.component.scss']
})
export class MioComponent implements OnInit {

  loading = false;
  btnLoading = false;
  combined = null;
  regions: IMioRegion[] = [];
  livingComplexes: IMioLivingComplex[] = [];
  licenses: IMioLicense[] = [];
  list: ILicenses[] = [];
  displayedColumns = ['id', 'region', 'city', 'name', 'number', 'startDate', 'endDate', 'option'];
  heightTable = 0;

  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'dd-mm-yyyy',
    // tslint:disable-next-line:max-line-length
    monthLabels: { 1: 'Янв', 2: 'Фев', 3: 'Мар', 4: 'Апр', 5: 'Май', 6: 'Июн', 7: 'Июл', 8: 'Авг', 9: 'Сен', 10: 'Окт', 11: 'Ноя', 12: 'Дек' },
    dayLabels: { su: 'Вс', mo: 'Пн', tu: 'Вт', we: 'Ср', th: 'Чт', fr: 'Пт', sa: 'Сб' },
    minYear: 2000,
    maxYear: 2030,
    showTodayBtn: false,
    showClearDateBtn: false,
    alignSelectorRight: true,
    openSelectorOnInputClick: true,
    height: '34px',
    width: '110px',
    inline: false
  };

  constructor(public dialog: MatDialog, private service: MioService, private snackBar: MatSnackBar) { }

  ngOnInit() {
    this.getData();
    this.heightTable = this.getHeight();
  }

  getData() {
    this.btnLoading = true;
    this.combined = combineLatest(
      this.service.getRegions(),
      this.service.getAllData(),
      this.service.getLicense(1, '')
    ).subscribe(res => {
      this.regions = res[0];
      this.livingComplexes = res[1];
      this.licenses = res[2];
      this.list = this.updateList(this.livingComplexes, this.licenses);
      this.btnLoading = false;
    });
  }

  updateList(livingComplexes: IMioLivingComplex[], licenses: IMioLicense[]): ILicenses[] {
    let res: ILicenses[] = licenses.map(lic => {
      let $spot;
      let $liv;
      livingComplexes.forEach(liv => {
        liv.spots.forEach(spot => {
          if (spot.id === lic.buildingId) {
            $liv = liv;
            $spot = spot;
          }
        });
      });
      const _date = new Date(lic.endDate);
      const licEndDate = { date: { year: _date.getFullYear(), month: _date.getMonth() + 1, day: _date.getDate() } };
      return {
        id: lic.buildingId,
        name: $liv.name,
        number: $spot.number,
        region: $liv.region.name,
        city: $liv.city.name,
        startDate: lic.startDate,
        endDate: licEndDate,
      }
    });
    return res;
  }

  btnDisable: boolean;
  selectedId: number;
  onDateChanged($date, id) {
    this.selectedId = id;
    let curDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).getTime();
    let date = new Date($date.jsdate).getTime();
    if (curDate > date) {
      alert('Нельзя выбирать дату меньше текущего дня');
      this.btnDisable = true;
    } else {
      this.btnDisable = false;
    }
  }

  selectedEndDate;
  extend(id) {
    this.list.find(f => f.id === id).startDate = moment().format('YYYY-MM-DD');
    this.prepareObj(this.list);
  }

  prepareObj(list: ILicenses[]) {
    let res: IMioLicense[] = list.map(l => {
      let $endDate = new Date(l.endDate.date.year, l.endDate.date.month-1, l.endDate.date.day);
      return {
        buildingId: l.id,
        startDate: l.startDate,
        endDate: moment($endDate).format('YYYY-MM-DD')
      }
    });
    this.sendLicense(res);
  }

  sendLicense(list: IMioLicense[]) {
    this.service.setLicense(1, '002', JSON.stringify(list)).subscribe(res => {
      this.snackBar.open('Доступ успешно продлен!', '', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'right',
        panelClass: ['snackbar-succes']
      });
    })
  }

  openAccessDialog() {
    const dialogRef = this.dialog.open(MioAccessDialogComponent, {
      width: '80%',
      height: '85%',
      data: { regions: this.regions, livingComplexes: this.livingComplexes, licenses: this.licenses },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result === 'cool') {
        }
      }
    });
  }

  getHeight() {
    let bodyHeight = document.body.clientHeight;
    let sectionHeight = document.getElementById('sectionWrapper').clientTop;
    let height = bodyHeight - sectionHeight - 250;
    return height;
  }

}


interface ILicenses {
  id: number;
  name: string;
  number: string;
  region: string;
  city: string;
  startDate: string;
  endDate: any;
}
